import http from '~/common/http'
export default {

    //客户统计分析
    getCount(params, action) {
        return http.get('/api/customer-count/' + action, {
            params: params
        });
    },
    // // 客户数量概览
    // getOriginData(params) {
    //     return http.get('/api/customer-count/origin-data', {
    //         params: params
    //     });
    // },
}


// WEBPACK FOOTER //
// ./src/services/CustomerCount.js